import api from '@/plugins/api'
import { directory, statementManual as endpoint } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'statementManual'

export default {
  state: () => ({
    statementManualList: {},
    statementManual: {},
    identificationAct: {},

    isSaveRuleBaseSetting: false,
    isSaveMediaLegalAct: false,

    legalActsNew: []
  }),
  getters: {
    legalActsFiltered: state => {
      return state.legalActsNew.filter(e => state.statementManual.legal_acts.includes(e.id))
    },
    legalActsNameFiltered: state => {
      return state.legalActsNew
        .filter((value, index, self) => self.findIndex(e => e.inspection_name === value.inspection_name) === index)
    },
    legalActsNumberFiltered: state => name => {
      if (!name) return []
      return state.legalActsNew
        .filter(value => value.inspection_name === name.inspection_name).map(e => ({ id: e.id, name: e.name }))
    }
  },
  actions: {
    async getStatementManualList (context, filter) {
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${ endpoint.statementManual() }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statementManualList', data: response.data })
      }
    },
    async getStatementManual (context, id) {
      const response = await api.get(endpoint.statementManual(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statementManual', data: response.data })
      }
    },
    async updateStatementManual (context, data) {
      const response = await api.patch(endpoint.statementManual(data.id), { body: data.body })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statementManual', data: response.data })
      }
    },

    async getStatementManualDocument (context, data) {
      const response = await api.get(endpoint.statementManualDocument(data.id))
      if (await requestValidation(response)) {
        return response.data.url
      }
      return false
    },

    async getStatementManualActIdentification (context, id) {
      const response = await api.get(endpoint.manualIdentificationActDocument(id))
      if (await requestValidation(response)) {
        return response.data.url
      }
      return false
    },

    async setStatementManualClientSignature (context, data) {
      const body = new FormData()
      body.append('client_watermark', data.signatureFile)

      const response = await api.post(endpoint.clientSignature(data.id), { body: body })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getStatementManual', data.id)
      return isResult
    },

    async setStatementManualSign (context, id) {
      const response = await api.post(endpoint.statementSign, { body: { document: id } })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getStatementManual', id)
        await context.dispatch('getManualIdentificationAct', id)
      }
      return isResult
    },


    // рішення по акту ідентифікації ===================

    async getManualIdentificationAct (context, id) {
      const response = await api.get(endpoint.identificationAct(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'identificationAct', data: response.data })
      } else {
        context.commit('SET_DATA', { store, state: 'identificationAct', data: {} })
      }
    },

    // ====================================

    saveRuleBaseSetting (context, data) {
      context.commit('SET_DATA', { store, state: 'isSaveRuleBaseSetting', data: data })
    },
    saveMediaLegalAct (context, data) {
      context.commit('SET_DATA', { store, state: 'isSaveMediaLegalAct', data: data })
    },
    async getLegalActsNew (context) {
      const response = await api.get(directory.legalActsNew)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'legalActsNew', data: response.data })
      }
    },

  }
}